<template>
  <div class="articlebox-content-mobile">
    <div
      class="img-box"
      :style="{
        backgroundImage:
          'url(' + 'https://help.yingzhongshare.com/' + article.showImage + ')',
      }"
      v-if="article.showImage"
    ></div>
    <div v-else class="img-cover"></div>

    <div class="info-box">
      <div class="info-title">
        {{ article.title }}
      </div>

      <div class="info-desc">
        {{ article.summary }}
      </div>

      <div class="info-footer">
        <span class="info-time">
          {{ article.created.split(" ")[0].split("-").join(".") }}
        </span>
        <span class="info-btn"></span>
      </div>
    </div>
  </div>
</template>

<script>
// import articleData from "../data";
export default {
  name: "ArticleBox",
  props: {
    articleData: Object,
  },
  data() {
    return {
      article: {},
    };
  },
  created() {
    this.article = this.articleData;
  },
};
</script>

<style lang="less" scoped>
.articlebox-content-mobile {
  background: #fff;
  box-shadow: 0px 11px 63px 0px #eff4fa;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  .img-box {
    height: 223px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    border-radius: 10px 10px 0px 0px;
  }
  .img-cover {
    height: 223px;
    border-radius: 10px 10px 0px 0px;
    background-image: url("../../../assets/img/pc/dynamic/article/img_cover.png");
    background-color: #f8f8f8;
    background-repeat: no-repeat;
    background-size: 20%;
    background-position: center center;
  }

  .info-box {
    flex: 1;
    padding: 14px 20px 24px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .info-title {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #222222;
      line-height: 30px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    }

    .info-desc {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #666666;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    }

    .info-footer {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #999999;
      line-height: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      .info-btn {
        background-image: url("../../../assets/img/mobile/dynamic/activity/circle_arrow@2x.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        width: 24px;
        height: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>